(function(){
  if(window.__cdrawerInit)return;window.__cdrawerInit=true;
  var d=document,root=d.documentElement;
  var drawer=d.getElementById('cart-drawer');if(!drawer)return;
  var backdrop=drawer.querySelector('.cdrawer-backdrop');
  var panel=drawer.querySelector('.cdrawer-panel');
  var itemsHolder=d.getElementById('cdrawer-items');
  var subtotalEl=d.getElementById('cdrawer-subtotal');
  var savingsRow=d.getElementById('cdrawer-savings');
  var savingsVal=d.getElementById('cdrawer-savings-value');
  var tplStr=d.getElementById('cdrawer-item-template').innerHTML;
  var lastTrigger=null;
  function esc(s){return (s||'').replace(/[&<>"']/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]});}
  function money(c){return '$'+((c/100).toFixed(2));}
  function htmlFor(it){
    var img=it.image||(it.featured_image&&it.featured_image.url)||(it.featured_image&&it.featured_image.src)||'//cdn.shopify.com/s/images/admin/no-image-large.gif';
    return tplStr.replace(/__KEY__/g,esc(it.key)).replace(/__IMG__/g,esc(img)).replace(/__TITLE__/g,esc(it.product_title)).replace(/__VARIANT__/g,esc(it.variant_title||'')).replace(/__QTY__/g,it.quantity).replace(/__PRICE__/g,money(it.line_price));
  }
  function updateCounts(cart){
    var countEls=d.querySelectorAll('cart-count');
    countEls.forEach(function(el){el.textContent=cart.item_count;});
    var dotEls=d.querySelectorAll('cart-dot');
    dotEls.forEach(function(el){if(cart.item_count>0){el.classList.add('is-visible');}else{el.classList.remove('is-visible');}});
  }
  function render(cart){
    itemsHolder.innerHTML='';
    cart.items.forEach(function(it){itemsHolder.insertAdjacentHTML('beforeend',htmlFor(it));});
    subtotalEl.textContent=money(cart.items_subtotal_price);
    if(savingsRow){
      if(cart.total_discount&&cart.total_discount>0){
        savingsRow.classList.remove('hidden');
        if(savingsVal)savingsVal.textContent=money(cart.total_discount);
      }else{
        savingsRow.classList.add('hidden');
      }
    }
    updateCounts(cart);
  }
  function openDrawer(){
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden','false');
    if(lastTrigger){lastTrigger.setAttribute('aria-expanded','true');}
    root.style.overflow='hidden';
    panel.focus({preventScroll:true});
  }
  function closeDrawer(){
    drawer.classList.add('hidden');
    drawer.setAttribute('aria-hidden','true');
    if(lastTrigger){lastTrigger.setAttribute('aria-expanded','false');}
    root.style.overflow='';
    if(lastTrigger&&lastTrigger.focus)lastTrigger.focus();
  }
  function loadCart(open){
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(c){render(c);if(open)openDrawer();});
  }
  function updateLine(key,qty){
    qty=isNaN(qty)?1:Math.max(0,qty);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){loadCart(false);});
  }
  function addItem(form){
    var data=new FormData(form);
    return fetch('/cart/add.js',{method:'POST',body:data}).then(function(r){return r.json();});
  }
  function onClick(e){
    var openBtn=e.target.closest('[data-action="open-cart"]');
    if(openBtn){
      e.preventDefault();
      lastTrigger=openBtn;
      loadCart(true);
      return;
    }
    if(e.target.id==='cdrawer-close'){
      e.preventDefault();
      closeDrawer();
      return;
    }
    if(e.target.id==='cdrawer-continue'){
      e.preventDefault();
      closeDrawer();
      return;
    }
    var qtyBtn=e.target.closest('.cdrawer-qty');
    if(qtyBtn){
      e.preventDefault();
      var wrap=qtyBtn.closest('.cdrawer-item');
      var key=wrap.dataset.key;
      var delta=parseInt(qtyBtn.dataset.delta,10);
      var input=wrap.querySelector('.cdrawer-qty-input');
      var qty=parseInt(input.value,10);if(isNaN(qty))qty=1;
      updateLine(key,qty+delta);
      return;
    }
    var remBtn=e.target.closest('.cdrawer-remove');
    if(remBtn){
      e.preventDefault();
      var w=remBtn.closest('.cdrawer-item');
      updateLine(w.dataset.key,0);
      return;
    }
  }
  function onChange(e){
    if(e.target.matches('.cdrawer-qty-input')){
      var wrap=e.target.closest('.cdrawer-item');
      updateLine(wrap.dataset.key,parseInt(e.target.value,10)||1);
    }
  }
  function onSubmit(e){
    var f=e.target;
    if(f.matches('form[action*="/cart/add"]')){
      e.preventDefault();
      addItem(f).then(function(){loadCart(true);});
    }
  }
  backdrop.addEventListener('click',closeDrawer);
  d.addEventListener('click',onClick,{passive:false});
  d.addEventListener('change',onChange);
  d.addEventListener('submit',onSubmit,{passive:false});
  d.documentElement.addEventListener('drawer:open',function(ev){ev.stopImmediatePropagation();ev.preventDefault();loadCart(true);},true);
  if(location.pathname.replace(/\/$/,'')==='/cart'){
    var qs=location.search||'';
    history.replaceState(null,'/','/'+qs);
    lastTrigger=d.querySelector('[data-action="open-cart"]');
    loadCart(true);
  }
})();